export default "__VITE_ASSET__9a171d76__"